module.exports = __webpack_public_path__ + "img/c2-tit_m.e13ea65b.png";